/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type PropsWithChildren } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import UFOSegment from '@atlaskit/react-ufo/segment';

import type { PrimaryProductKey } from '../../constants/products';
import { useAppContext } from '../app-context';
import { WidthObserverElement } from '../width-observer';

const styles = cssMap({
	layout: {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
	},
});

const NAV3_HEIGHT = 56;
const NAV4_HEIGHT = 48;

export const Layout = ({
	children,
	headerOffset = 0,
	primaryProduct: _primaryProduct,
}: PropsWithChildren<{
	headerOffset?: number;
	primaryProduct?: PrimaryProductKey;
}>): JSX.Element => {
	const { isNav4Enabled } = useAppContext();

	const headerHeight = (isNav4Enabled ? NAV4_HEIGHT : NAV3_HEIGHT) + headerOffset;
	return (
		<UFOSegment name="search-page-layout">
			<WidthObserverElement id="layout">
				<Box
					testId="search-page-layout"
					xcss={styles.layout}
					style={{ height: `calc(100vh - ${headerHeight}px)` }}
				>
					{children}
				</Box>
			</WidthObserverElement>
		</UFOSegment>
	);
};
